import { useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useSetSimulatorStatus = () => {
  const queryClient = useQueryClient();

  return apiClient.customsSimulator.setNotificationsStatus.useMutation({
    onError: (error) => {
      showErrorToast(error, 'Error setting simulator status');
    },
  });
};
